import React from 'react'
import classNames from 'classnames'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'
import OriginalPaper, { PaperProps as OriginalProps } from '@material-ui/core/Paper'
import { Color } from 'themes/types'
import { Omit } from 'types'

export interface Props extends Omit<OriginalProps, 'classes'> {
  color?: Color
  className?: string,
  pad?: 'small' | 'medium' | 'large'
}

const styles = (theme: Theme) => createStyles({
  primary: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main
  },
  secondary: {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.secondary.main
  },
  tertiary: {
    color: theme.palette.tertiary.contrastText,
    backgroundColor: theme.palette.tertiary.main
  },
  accent: {
    color: theme.palette.accent.contrastText,
    backgroundColor: theme.palette.accent.main
  },
  error: {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.error.main
  },
  smallPadding: {
    padding: theme.spacing()
  },
  mediumPadding: {
    padding: theme.spacing() * 2
  },
  largePadding: {
    padding: theme.spacing() * 3
  },
})

type InjectedProps = Props & WithStyles

const Paper: React.SFC<InjectedProps> = ({ classes, className, pad, color, ...props }) => (
  <OriginalPaper
    square
    elevation={0}
    {...props}
    className={classNames(classes[color || 'inherit'], classes[`${pad}Padding`], className)}
  />
)

export default withStyles(styles)(Paper)
